import React from "react";
import { useViewContext } from "folksam-ui";
export default function FieldWidth({ constrain, children }) {
  const { isMobile } = useViewContext();
  const widthConstraints = {
    S: "25%",
    M: "50%",
    L: "100%"
  };
  const mobileWidthConstraints = {
    S: "50%",
    M: "75%",
    L: "100%"
  };
  if (isMobile) {
    return (
      <div style={{ maxWidth: mobileWidthConstraints[constrain] }}>
        {children}
      </div>
    );
  }
  return (
    <div style={{ maxWidth: widthConstraints[constrain] }}>{children}</div>
  );
}
